// ASA logo — stylised tri-petal triangle in blue gradient
export const Logo = ({ size = 56 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="asa-grad" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#5BBEFC" />
        <stop offset="0.5" stopColor="#2EA3F2" />
        <stop offset="1" stopColor="#1266B8" />
      </linearGradient>
    </defs>
    {/* top petal */}
    <path d="M50 8 L62 38 L50 50 L38 38 Z" fill="url(#asa-grad)" opacity="0.95"/>
    {/* bottom-left petal */}
    <path d="M14 70 L42 56 L50 70 L34 86 Z" fill="url(#asa-grad)" opacity="0.85"/>
    {/* bottom-right petal */}
    <path d="M86 70 L58 56 L50 70 L66 86 Z" fill="url(#asa-grad)" opacity="0.85"/>
  </svg>
);

export const Avatar = ({ user, size = 36 }) => {
  if (!user) return null;
  const init = (user.short || user.name?.slice(0, 1) || '?').toUpperCase();
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `linear-gradient(135deg, ${user.color || '#2EA3F2'}, ${user.color ? user.color + 'CC' : '#1266B8'})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Sora',
        fontWeight: 700,
        fontSize: size * 0.4,
        color: '#fff',
        flexShrink: 0,
      }}
    >
      {init}
    </div>
  );
};
